var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-preloader",class:{ 'is-loading': _vm.show }},[_c('div',{staticClass:"ui-preloader__progressbar",attrs:{"role":"progressbar","aria-busy":_vm.show ? 'true' : false}})])
}
var staticRenderFns = []

export { render, staticRenderFns }